import { MAX_PRINT_METHOD_DESCRIPTION_LENGTH } from '@repo/api-contracts';
import type { FormEvent, ReactElement } from 'react';
import { Button } from '@/shared/ui';

interface PrintMethodDescriptionFormProps {
  /** 입력의 접근성 라벨 — 관례상 `${방식명} 설명`. */
  readonly ariaLabel: string;
  readonly value: string;
  readonly isPending: boolean;
  readonly onChange: (value: string) => void;
  readonly onSubmit: () => void;
  readonly onCancel: () => void;
}

/** 행 안에서 설명을 고치는 인라인 폼 — 여러 줄 입력과 저장·취소. 빈 값으로 저장하면 설명이 지워진다. */
export const PrintMethodDescriptionForm = ({
  ariaLabel,
  value,
  isPending,
  onChange,
  onSubmit,
  onCancel,
}: PrintMethodDescriptionFormProps): ReactElement => {
  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <textarea
        aria-label={ariaLabel}
        value={value}
        maxLength={MAX_PRINT_METHOD_DESCRIPTION_LENGTH}
        rows={3}
        placeholder="고객에게 보여 줄 설명 — 예: 자외선으로 즉시 경화하는 잉크라 곡면·투명 소재에도 선명합니다."
        onChange={(event) => onChange(event.target.value)}
        className="w-full rounded-md border bg-background px-3 py-2 text-sm"
        // biome-ignore lint/a11y/noAutofocus: "수정" 버튼을 눌러 연 인라인 폼이라 바로 입력하도록 포커스를 준다.
        autoFocus
      />
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs text-muted-foreground tabular-nums">
          {value.length}/{MAX_PRINT_METHOD_DESCRIPTION_LENGTH}
        </span>
        <span className="flex gap-1">
          <Button type="button" variant="ghost" size="sm" onClick={onCancel}>
            취소
          </Button>
          <Button type="submit" size="sm" isLoading={isPending}>
            설명 저장
          </Button>
        </span>
      </div>
    </form>
  );
};
